import React, { Component } from 'react';
import close from "../images/icons/close.png"
import calender from "../images/icons/calender.png"
import clock from "../images/icons/clock.png"
import dish from "../images/icons/dish.png"
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getData } from '../services';
export default class booktable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bookingDate: new Date(),
      bookingTime: '',
      seatCount: '',
      name: localStorage.getItem('displayName'),
      email: window.sessionStorage.getItem('userEmailId'),
      mobileNumber: window.sessionStorage.getItem('userMobileNumber'),
      message: '',
    };
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSeatCountChange = this.handleSeatCountChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleMobileNumberChange = this.handleMobileNumberChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
  }
  handleButtonClick = (event) => {
    var personalMsgError = "";
    let formIsValid;
    $(".personalMsgError").text("");
    let bookingTime = this.state.bookingTime;
    let bookingDate = this.state.bookingDate;
    let createdBy = localStorage.getItem('userId');
    let seatCount = this.state.seatCount;
    let name = this.state.name;
    let email = this.state.email;
    let mobileNumber = this.state.mobileNumber;
    if (!bookingDate) {
      personalMsgError = "Please enter Booking Date";
      formIsValid = false;
    }
    else if (!bookingTime) {
      personalMsgError = "Please enter Booking Time";
      formIsValid = false;
    }
    else if (!seatCount) {
      personalMsgError = "Please enter Table Seat";
      formIsValid = false;
    }
    else if (!name) {
      personalMsgError = "Please enter Name";
      formIsValid = false;
    }
    else if (!email) {
      personalMsgError = "Please enter Email Id";
      formIsValid = false;
    }
    else if (!mobileNumber) {
      personalMsgError = "Please enter Mobile Number";
      formIsValid = false;
    }
    else {
      formIsValid = true;
    }
    if (!formIsValid) {
      $(".personalMsgError").text(personalMsgError);
      return false;
    }
    else {
      let storeId = window.sessionStorage.getItem('storeId')
      const postData = {
        functionName: 'rtbookyourtable',
        bookingDate: this.state.bookingDate,
        bookingTime: this.state.bookingTime,
        createdBy: createdBy,
        email: this.state.email,
        message: this.state.message,
        mobileNumber: this.state.mobileNumber,
        name: this.state.name,
        seatCount: this.state.seatCount,
        storeId: storeId
      }
      getData(postData).then((data) => {
        if (data.data.success === 1) {
          $(".personalMsgError").text("Success");
          window.location.reload();
        }
      });
    }
  }
  handleChange = date => {
    this.setState({
      bookingDate: date
    });
  };
  handleTimeChange = time => {
    this.setState({ bookingTime: time });
  };
  handleSeatCountChange = (event) => {
    this.setState({
      seatCount: event.target.value
    });
  }
  handleNameChange = (event) => {
    this.setState({
      name: event.target.value
    });
  }
  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value
    });
  }
  handleMobileNumberChange = (event) => {
    this.setState({
      mobileNumber: event.target.value
    });
  }
  handleMessageChange = (event) => {
    this.setState({
      message: event.target.value
    });
  }
  componentDidMount() {
    $(".saveClose").click(function () {
      $(".bookTableSection").hide();
    });
  }
  render() {
    const { bookingDate, bookingTime, seatCount, name, email, mobileNumber, message } = this.state;
    return (
      <div className="booktable" id="bookTableId">
        <div className="popOverlay"></div>
        <div className="loginPop bookTable">
          <div className="loginHead">
            <span className="saveClose"><img src={close} alt="" /></span>
            <div className="loginText">BOOK YOUR TABLE NOW!</div>
          </div>
          <div className="saveMoreContent customizeContent">
            <div className="errorMsg personalMsgError"></div>
            <div className="popFormList">
              <div className="popFormHalf">
                <label className="formInputLabel">Date for<sup>*</sup></label>
                <span className="formWidthSection">
                  <img src={calender} alt="" className="formImage" />
                  <DatePicker
                    selected={this.state.bookingDate}
                    onChange={this.handleChange} dateFormat="yyyy-MM-dd " value={bookingDate} className="formInputField" placeholder="Booking date"
                  />
                </span>
              </div>
              <div className="popFormHalf">
                <label className="formInputLabel">Time<sup>*</sup></label>
                <span className="formWidthSection">
                  <DatePicker
                    selected={this.state.bookingTime}
                    onChange={this.handleTimeChange.bind(this)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa" value={bookingTime} className="formInputField" placeholder="Booking time"
                  />
                  <img src={clock} alt="" className="formImage" />
                </span>
              </div>
            </div>
            <div className="popFormList">
              <div className="popFormHalf">
                <label className="formInputLabel">Table Seat<sup>*</sup></label>
                <span className="formWidthSection">
                  <input type="text" className="formInputField" placeholder="No of peoples" value={seatCount} onChange={this.handleSeatCountChange} />
                  <img src={dish} alt="" className="formImage" />
                </span>
              </div>
            </div>
            <div className="popFormList">
              <label className="formInputLabel">Name<sup>*</sup></label>
              <span className="formWidthSection">
                <input type="" className="formInputField" value={name} onChange={this.handleNameChange} />
              </span>
            </div>
            <div className="popFormList">
              <label className="formInputLabel">Email Id<sup>*</sup></label>
              <span className="formWidthSection">
                <input type="" className="formInputField" value={email} onChange={this.handleEmailChange} />
              </span>
            </div>
            <div className="popFormList">
              <label className="formInputLabel">Phone<sup>*</sup></label>
              <span className="formWidthSection">
                <input type="" className="formInputField" value={mobileNumber} onChange={this.handleMobileNumberChange} />
              </span>
            </div>
            <div className="popFormList">
              <label className="formInputLabel">Message</label>
              <span className="formWidthSection">
                <textarea className="formInputTextarea" value={message} onChange={this.handleMessageChange}></textarea>
              </span>
            </div>
          </div>
          <div className="bookButtonSection">
            <p>Kindly note, reservation need to be made atleast 12 hours in advance on Weekends</p>
            <span className="mainPopButton" onClick={this.handleButtonClick}>Book Request</span>
          </div>
        </div>
      </div>
    )
  }
}